import {
  getFlockproPrietorInfo,
  saveMeasureInvite,
  getMeasureInvite,
  determineMeasure,
  getMeasureInfo,
  getMeasureStatus,
  saveMeasureEvaluation,
  getMeasureEvaluation,
  getMeasureBaseInfo,
  getMeasureReport
} from '@/api/measure.js'

const state = {
}

const mutations = {
}

const actions = {
  // 获取群客户信息
  getFlockproPrietorInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getFlockproPrietorInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 添加勘测邀请函
  saveMeasureInvite({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveMeasureInvite(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取勘测邀请函
  getMeasureInvite({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMeasureInvite(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 客户确认勘测邀请
  determineMeasure({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      determineMeasure(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 05-获取勘测报告
  getMeasureInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMeasureInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 06-获取勘测状态
  getMeasureStatus({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMeasureStatus(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 07-添加勘测评价
  saveMeasureEvaluation({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveMeasureEvaluation(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 08-获取勘测评价
  getMeasureEvaluation({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMeasureEvaluation(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 09-获取勘测基础信息
  getMeasureBaseInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMeasureBaseInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 09-获取勘测基础信息
  getMeasureReport({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMeasureReport(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
